import { Card, Container } from '@mui/material';
import { useState } from 'react';
import { GeneralTable } from 'src/components/general';
import Page from 'src/components/Page';
import { NOTIFICATION_STYLE_LIST_TABLE_HEAD } from 'src/constants/tableHeads';
import { useNotificationStyleList } from 'src/hooks/dashboard/useNotificationStyleList';
import useTable from 'src/hooks/useTable';
import { NotificationStyleListTableBreadcrumb, NotificationStyleListTableRow } from 'src/sections/@dashboard/notification-style-list';

export default function NotificationStyle({ selectPopupFrame }) {
  const useTableOptions = useTable();
  const { selected, setSelected } = useTableOptions;

  const [selectedRow, setSelectedRow] = useState();

  const { tableData, isLoading, deleteLoading, handleDeleteRow, handleDeleteRows, handleEditRow, openConfirmDelete, setOpenConfirmDelete } =
    useNotificationStyleList({ selected, setSelected, selectPopupFrame });

  const title = 'مدیریت فریم اعلان ها';

  return (
    <Page title={title}>
      <Container maxWidth={false}>
        {selectPopupFrame ? null : <NotificationStyleListTableBreadcrumb title={title} />}

        <Card>
          <GeneralTable
            tableContainerSX={{
              position: 'relative',
              maxHeight: { xs: 'calc(100dvh - 180px)', lg: 'calc(100dvh - 110px)' },
            }}
            rowID="NotificationStyleID"
            tableData={tableData}
            headLabel={NOTIFICATION_STYLE_LIST_TABLE_HEAD}
            isLoading={isLoading}
            isDeleteLoading={deleteLoading}
            onEditRow={handleEditRow}
            onDeleteRow={handleDeleteRow}
            onDeleteRows={handleDeleteRows}
            CustomTableRow={NotificationStyleListTableRow}
            openConfirmDelete={openConfirmDelete}
            setOpenConfirmDelete={setOpenConfirmDelete}
            useTableOptions={useTableOptions}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            selectPopupFrame={selectPopupFrame}
            hasDeleteOption={!selectPopupFrame}
          />
        </Card>
      </Container>
    </Page>
  );
}
